import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" />, 'CallMade');
